import React, { useState } from "react";
import emailjs from "emailjs-com";
import WhatsAppFloatButton from "../components/WhatsAppFloatButton";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const phoneRegex = /^[6-9]\d{9}$/; // Validates Indian phone numbers
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Validates email format

    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!emailRegex.test(formData.email)) newErrors.email = "Invalid email format.";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required.";
    else if (!phoneRegex.test(formData.phone)) newErrors.phone = "Invalid phone number.";
    if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
    if (!formData.message.trim()) newErrors.message = "Message is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear error for the field being edited
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    const serviceID = "service_i0d1te4"; // Replace with your EmailJS service ID
    const ownerTemplateID = "template_e8a6wnf"; // Replace with your EmailJS template ID for the owner
    const customerTemplateID = "template_4alf55r"; // Replace with your EmailJS template ID for the customer
    const userID = "XkzCXjNAEyHBnH-Ew"; // Replace with your EmailJS user ID

    // Data to send in the email
    const emailData = {
      customer_name: formData.name,
      customer_email: formData.email,
      customer_phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
    };

    try {
      // Send email to the owner
      await emailjs.send(serviceID, ownerTemplateID, emailData, userID);
      console.log("Email sent to the owner.");

      // Send email to the customer
      await emailjs.send(serviceID, customerTemplateID, emailData, userID);
      alert("Your message has been sent! A confirmation email has been sent to you.");
      setFormData({ name: "", email: "", phone: "", subject: "", message: "" }); // Reset form
    } catch (error) {
      console.error("Failed to send email:", error);
      alert("Failed to send your message. Please try again later.");
    }
  };

  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Contact Us
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    Contact
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* Contact Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Contact Us
            </h6>
            <h1 className="mb-5">Contact For Any Query</h1>
          </div>
          <div className="row g-4">
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
              <h5>Get In Touch</h5>
              <p className="mb-4">
                You can reach us through the following contact details. We are here to assist you with any inquiries or bookings you may have.
              </p>
              <div className="d-flex mb-4">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary mt-1"
                  style={{ width: 50, height: 50 }}
                >
                  <i className="fa fa-map-marker-alt text-white" />
                </div>
                <div className="ms-3">
                  <h5 className="text-primary">Office</h5>
                  <p className="mb-0">Kothari Tour and Travels
                    Vaishali Nagar, Near HP Petrol Pump
                    Jaipur, Rajasthan – 302021
                    India</p>
                </div>
              </div>
              <div className="d-flex mb-4">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary mt-1"
                  style={{ width: 50, height: 50 }}
                >
                <a href="tel:+919610415221">
                   <i className="fa fa-phone-alt text-white" />
                </a>
                 
                </div>
                <div className="ms-3">
                  <h5 className="text-primary">Mobile</h5>
                  <p className="mb-0">
                    <a
                      href="tel:+919610415221"
                      style={{ color: 'inherit', textDecoration: 'none' }}
                    >
                      +91 9610415221
                    </a>
                  </p>
                </div>
              </div>
              <div className="d-flex">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary mt-1"
                  style={{ width: 50, height: 50 }}
                >
                  <i className="fa fa-envelope-open text-white" />
                </div>
                <div className="ms-3">
                  <h5 className="text-primary">Email</h5>
                  <p className="mb-0">
                    <a
                      href="mailto:kotharitourandtravelservices@gmail.com"
                      style={{ color: 'inherit', textDecoration: 'none' }}
                    >
                      kotharitourandtravelservices@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
              <iframe
                className="position-relative rounded w-100 h-100"
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3557.9406386167184!2d75.71350727543927!3d26.9053789766515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDU0JzE5LjQiTiA3NcKwNDInNTcuOSJF!5e0!3m2!1sen!2sin!4v1746386489393!5m2!1sen!2sin"
                frameBorder={0}
                style={{ minHeight: 300, border: 0 }}
                allowFullScreen=""
                aria-hidden="false"
                tabIndex={0}
              />
            </div>
            <div
              className="col-lg-4 col-md-12 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                        id="name"
                        name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                      />
                      <label htmlFor="name">Your Name</label>
                      {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        id="email"
                        name="email"
                        placeholder="Your Email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                      <label htmlFor="email">Your Email</label>
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="tel"
                        className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                        id="phone"
                        name="phone"
                        placeholder="Your Phone Number"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required
                      />
                      <label htmlFor="phone">Your Phone Number</label>
                      {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className={`form-control ${errors.subject ? "is-invalid" : ""}`}
                        id="subject"
                        name="subject"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                      />
                      <label htmlFor="subject">Subject</label>
                      {errors.subject && <div className="invalid-feedback">{errors.subject}</div>}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className={`form-control ${errors.message ? "is-invalid" : ""}`}
                        placeholder="Leave a message here"
                        id="message"
                        name="message"
                        style={{ height: 100 }}
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                      />
                      <label htmlFor="message">Message</label>
                      {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                    </div>
                  </div>
                  <div className="col-12">
                    <button className="btn btn-primary w-100 py-3" type="submit">
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <WhatsAppFloatButton phoneNumber="919610415221" />
      {/* Contact End */}
    </div>
  );
}

export default Contact;